import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import { createTheme } from '@hiiretail/synergy-ui';
import { ThemeProvider } from 'styled-components';
import { GlobalFeatureFlagsProvider } from './providers/GlobalFeatureFlagsContext/GlobalFeatureFlagsContext';
import { TenantInfoProvider } from 'providers/TenantInfo/TenantInfo';

declare global {
  interface Window {
    env: {
      launchDarkly: {
        clientSideID: string;
      };
    };
  }
}

const theme = createTheme();
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <TenantInfoProvider>
      <GlobalFeatureFlagsProvider>
        <App />
      </GlobalFeatureFlagsProvider>
    </TenantInfoProvider>
  </ThemeProvider>,
  document.getElementById('root'),
);
